import React, { useContext } from "react";

import { Text } from "mondrian-react";
import styled from "styled-components";
import mondrian from "core/config/theme";
import { Link } from "mondrian-react";
import { atributteFactory} from "core/Utils/Analytics/tagService";
import { TagTypeGa4 } from "core/Utils/Analytics/tagType";
import tagAdapter from "core/Utils/Analytics/tagAdapter";
import { store } from "store.js";
const FooterWrapper = styled.div`
  margin-top: ${mondrian.spacingStackXxs};
`;
const FooterDiv = styled.div`
  margin-top: ${mondrian.spacingStackMd};
`;
const LinkWrapper = styled.div`
  display: inline-block;
  text-decoration: underline;
  @media (max-width: 366px) {
    &:first-child {
      margin-right: 0px;
    }
  }
`;

function handleTagAdapter(ev, currentFlow)  {
const optionsDefault = {nome_item:ev?.target?.textContent}
if(currentFlow ==="customer2fa"){
  tagAdapter(optionsDefault,TagTypeGa4.FOOTER)
  }
  }
export default function Footer(props) {


  const globalState = useContext(store);
  const { state } = globalState;
  const {currentFlow}  = state.analytics;

  let eventCategoryPortal = "minha-claro:meu-perfil";
  let eventActionPortal = "clique:footer";
  let labelPortal = "termo-de-uso-e-politica-de-privacidade";

  let attributePortal =atributteFactory(currentFlow,eventCategoryPortal,eventActionPortal,labelPortal);

  let eventCategoryPolitica = "minha-claro:meu-perfil";
  let eventActionPolitica = "clique:footer";
  let labelPolitica = "termo-de-uso-e-politica-de-privacidade";

  let attributePolitica =atributteFactory(currentFlow,eventCategoryPolitica,eventActionPolitica,labelPolitica);
  return (
    <FooterDiv>
      <footer className="mdn-Footer mdn-Footer--simple mdn-Footer--signature">
        <div className="mdn-Container">
          <div className="mdn-Footer-content">
            <div className="mdn-Footer-disclaimer">
              <LinkWrapper className="mdn-Link--inverse">
                <Link
                  tag="a"

                  onClick={ (e) => handleTagAdapter(e,currentFlow)}
                  default={true}
                  href="https://www.claro.com.br/privacidade"
                  target="_blank"
                  rel="noopener noreferrer"
                  {...attributePortal}
                  id="mdn-Footer"
                  tabIndex="99"
                >
                  Portal de Privacidade
                </Link>
              </LinkWrapper>
              <span className="mdn-Icon-bolinha mdn-Icon--sm separador-footer"></span>
              <LinkWrapper className="mdn-Link--inverse">
                <Link
                  tag="a"
                  default={true}
                  onClick={ (e) => handleTagAdapter(e,currentFlow)}
                  href="https://www.claro.com.br/privacidade/politica-de-privacidade"
                  target="_blank"
                  rel="noopener noreferrer"
                  {...attributePolitica}
                  tabIndex="100"
                >
                  Política de Privacidade
                </Link>
              </LinkWrapper>
              <FooterWrapper className="direitos-reservados">
                <Text caption inverse>
                  © 2022 Claro. Todos os direitos reservados.
                </Text>
              </FooterWrapper>
            </div>
            <div className="mdn-Footer-logo"></div>
          </div>
        </div>
      </footer>
    </FooterDiv>
  );
}
